import { Store } from "@bryntum/schedulerpro";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { IncentivePointTag } from "../models/IncentivePointTag.jsx";

export class SwivuIncentivePointTagsStore extends Store {
  static get $name() {
    return "SwivuIncentivePointTagsStore";
  }

  static get configurable() {
    return {
      modelClass: IncentivePointTag,
      id: STORE_KEYS.incentivePointTagsStore,
      storeId: STORE_KEYS.incentivePointTagsStore
    };
  }
}
